import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import ModeInputHelperText from './ModeInputHelperText.react';

export default class NumberInput extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    return (
      <FormGroup className='budget-constraint-group'>
        <FormControl
          type='number'
          value={this.props.value}
          min={this.props.min}
          max={this.props.max}
          step={this.props.step}
          onChange={this.onChange}
        />
        <ModeInputHelperText
          text={this.props.helperText}
          tooltip={this.props.tooltip}
        />
      </FormGroup>
    );
  }
}

NumberInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  min: PropTypes.string,
  max: PropTypes.string,
  step: PropTypes.string,
  helperText: PropTypes.string,
  tooltip: PropTypes.string,
};
